import noFavorite from '../../../assets/images/noFavorite.png'
import favorite from '../../../assets/images/yesFavorite.png'
import { useAppStore } from '../../../store/useAppStore'
import {
  useAddToFavorites,
  useRemoveFromFavorites,
} from '../../../hooks/useApi'

interface FavoriteButtonProps {
  cardId: number
}

/**
 * Избранное на карточке главной. Иконки те же, что в карточках «Базы», —
 * разнобоя между экранами быть не должно.
 *
 * Состояние берём из общего стора: его наполняет загрузка избранного, поэтому
 * сердечки на разных экранах не расходятся. Клик не должен открывать карточку:
 * кнопка лежит внутри кликабельной карточки.
 */
const FavoriteButton = ({ cardId }: FavoriteButtonProps) => {
  const favorites = useAppStore(state => state.favorites)
  const add = useAddToFavorites()
  const remove = useRemoveFromFavorites()

  const isFavorite = favorites.includes(String(cardId))

  return (
    <button
      type="button"
      className="home-favorite"
      title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      aria-pressed={isFavorite}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()
        if (isFavorite) remove.mutate({ card_id: cardId })
        else add.mutate({ card_id: cardId })
      }}
    >
      <img
        src={isFavorite ? favorite : noFavorite}
        alt={isFavorite ? 'В избранном' : 'Добавить в избранное'}
        className="home-favorite__icon"
      />
    </button>
  )
}

export default FavoriteButton
